import { useState } from "react";
import { useHistory } from "react-router";
import PathsConfig from "../Config/RoutePaths";
import ApiService from "../Services/ApiService";

const useSuscripcionesBajaWeb = () => {
    const history = useHistory();
    const { REACT_APP_APIPAYWALL } = process.env;

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    const outFunc = async (payload) => {
        setIsLoading(true);
        const pathUrl = `${REACT_APP_APIPAYWALL}Suscripcion/SolicitarBajaWeb`;
        ApiService.post(pathUrl, payload)
            .then(data => {
                if (data && data.code === "0000") {
                    console.log("DataResponse: ", data.response);
                    const params = {
                        pathname: PathsConfig.MisSuscripciones,
                        state: {
                            cambiosGuardados: true,
                            data: data.response
                        }
                    };
                    history.push(params);
                } else {
                    console.log("Data diferente a code '0000': ", data.message);
                    setError(data.message);
                    setIsLoading(false);
                };
            })
            .catch(error => {
                console.log("Catch error: ", error);
                setError(error);
                setIsLoading(false);
            })
            .finally(_ => {
                window.scrollTo(0, 0)
            });
    };

    return [data, error, isLoading, outFunc];
};

export default useSuscripcionesBajaWeb;
